import React from 'react'
import Box from '@material-ui/core/Box'
import { useFormContext } from 'react-hook-form'
import TextField from '@material-ui/core/TextField'
import {
  getFieldProps,
  requiredLabel,
  useCreateProfileFieldStyles,
} from '../create-profile-form/field-styles'

export const Contact = () => {
  const classes = useCreateProfileFieldStyles()
  const fieldProps = getFieldProps(classes)
  const { register, errors } = useFormContext()

  const renderField = ({ name, label, isRequired, type = 'text' }) => (
    <TextField
      {...fieldProps}
      name={name}
      label={isRequired ? requiredLabel(label) : label}
      type={type}
      inputRef={register()}
      error={!!errors[name]}
    />
  )

  return (
    <Box className={classes.fieldStack}>
      {renderField({
        name: 'email',
        label: 'Email',
        isRequired: true,
      })}
      <Box className={classes.fieldRow}>
        {renderField({
          name: 'phoneNumber',
          label: 'Phone',
        })}
        {renderField({
          name: 'phoneExt',
          label: 'Ext.',
        })}
      </Box>
      {renderField({
        name: 'mobileNumber',
        label: 'Mobile',
      })}
    </Box>
  )
}

export default Contact
